// extracted by mini-css-extract-plugin
export default {"intro-main":"UserIntroPrompt_intro-main__KNcuS","cross":"UserIntroPrompt_cross__8ovld"};